module.exports = __webpack_public_path__ + "static/thedoofi.com-1a46bbcb4c4109aaaf5e98435cd00eba.png";